/*HCORZ
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 11/07/2025 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import { IconButton, Snackbar } from "@mui/material";
import MiAlert from "@mui/material/Alert";
import CloseIcon from "@mui/icons-material/Close";
import { useLayout } from "../../context/System/LayoutContext";

export default function HcorzAlert() {
  const {
    alert: { open, message, severity },
    handleCloseAlert,
  } = useLayout();

  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={handleCloseAlert}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <MiAlert 
        onClose={handleCloseAlert}
        severity={severity}
        sx={{ width: "100%" , backgroundColor: severity === "error" ? "red":"yellow", color: severity === "error" ? "white":"black"}}
        variant="filled"
        action={
          <IconButton
            onClick={handleCloseAlert}
            color="inherit"
            style={{ backgroundColor: severity === "error" ? "white":"black", color: severity === "error" ? "black":"yellow"}}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        }
      >
        {message}
      </MiAlert>
    </Snackbar>
  );
}
